module.exports = __webpack_public_path__ + "img/horizontal_4_5_5010.7a9c72b1.png";